import api from 'api'

export interface BuildInfo {
	commit: string
	commitUrl: string
	refName: string
	buildDate: string
}

export const getBuildInfo = () => api.get<BuildInfo>('/build-info')
